export const upsertDeliveryWorkEndpoint = (shipmentUid: string, visitId: number) =>
  `/shipments/${shipmentUid}/visits/${visitId}/delivery-work`
